// Namespaced
export const namespaced = true;

export const state = {};
export const mutations = {};
export const actions = {
  myAccount({ dispatch }, payload) {
    dispatch("getCreatorInformations", null, { root: true }).then(creator => {
      if (
        payload.atLogin &&
        !creator.websites.length &&
        !creator.youtubeChannels.length
      ) {
        setTimeout(() => {
          dispatch("navigation/openAskToCompleteProfileView", null, {
            root: true
          });
        }, 1500);
      }
    });
  }
};
export const getters = {};
